export const isWithinDate = (isoDateString, days = 60) => {
  const currentDate = new Date()
  const dateToCheck = new Date(isoDateString)
  const differenceInTime = currentDate.getTime() - dateToCheck.getTime()
  const differenceInDays = differenceInTime / (1000 * 3600 * 24)

  return differenceInDays <= days
}

export const lockBody = () => {
  const body = document.body
  body.style.overflow = 'hidden'
  body.style.paddingRight = 'var(--scrollbar-width)'
  body.style.setProperty('--pos-right', 'var(--scrollbar-width)')
}

export const unlockBody = () => {
  const body = document.body
  body.style.overflow = ''
  body.style.paddingRight = ''
  body.style.setProperty('--pos-right', '0px')
}
